module.exports = __webpack_public_path__ + "static/img/fg5.5f2e0bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/fg5.png
// module id = dloE
// module chunks = 0